import { Link, useLocation } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';

export default function NoAccessPage() {
  const location = useLocation();
  return (
    <AppLayout>
      <div className="flex flex-col items-center justify-center min-h-[50vh] text-center px-6">
        <div className="text-6xl font-bold text-zinc-300 mb-4">403</div>
        <h1 className="text-2xl font-semibold text-zinc-900 mb-2">You don't have access to this page</h1>
        <p className="text-zinc-600 mb-6 max-w-md">
          This page requires permissions your account doesn't currently have.
          If you think this is a mistake, ask your HR admin to review your role assignment.
        </p>
        <p className="text-xs text-zinc-400 mb-6 font-mono">{location.pathname}</p>
        <div className="flex gap-3">
          <Link to="/dashboard" className="px-4 py-2 bg-zinc-900 text-white rounded-md hover:bg-zinc-800">
            Go to dashboard
          </Link>
          <Link to="/help" className="px-4 py-2 border border-zinc-300 rounded-md hover:bg-zinc-50">
            Get help
          </Link>
        </div>
      </div>
    </AppLayout>
  );
}
